import { Component, NgModule, AfterViewChecked, OnInit, Inject, APP_INITIALIZER, ElementRef, ViewChild, SimpleChanges } from '@angular/core'
import { BrowserModule } from '@angular/platform-browser'
import { FormBuilder, FormGroup } from '@angular/forms';
import { SharedService } from './shared.service';
import { BarComponent } from './bar.component';
import { MapComponent } from './map.component';
import { WltComponent } from './wlt.component';
import { VdtComponent } from './vdt.component';
import { LoginComponent } from './login.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { DirectionsMapDirective } from './map.directive';
import { Http, HttpModule } from '@angular/http';
import { AgmCoreModule } from '@agm/core';
import { NguiModule } from '@ngui/ngui';
import { CommonModule } from '@angular/common';
import { ViewTabs, User, VisitFilterType, VisitEventType, VisitSelectionEvent } from './model/model.class';
import { Labels } from './model/language.model.class';
import { KpiComponent } from './kpi.component';
import { ChartsModule } from 'ng2-charts';
import { ConfigService } from './service/config.service';
import { WindowRefService } from './service/windowRef.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { MeetingInfoComponent } from './meeting-info.component';
import { HeaderComponent } from './header.component';
import { BottomBarComponent } from './bottom-bar/bottom-bar.component';
import { VisitFilterPopupComponent } from './visit-filter-popup/visit-filter-popup.component';

declare var componentHandler: any;
declare function getUrlTokenServiceIframe(): any;

@Component({
  selector: 'app-root',
  templateUrl: './app.module.html',
  styleUrls: ['./app.module.css'],
  providers: [SharedService]
})
export class App implements AfterViewChecked, OnInit {
  isPopoverOpen = false;
  groupedIcons: {
    [groupName: string]: {
      description: string,
      items: { icon: string, label: string }[]
    }
  } = {};
  token: string;
  loginMessage: string;
  labels: Labels;
  languages: Array<string>;
  language: string;
  accounId: string;
  accountName: string;
  viewTabs = ViewTabs;
  actualTab = ViewTabs.Map;
  user: User;

  authurl: string;
  tokenServiceFolder: string;

  urlSafe: SafeResourceUrl;
  iframeBaseUrl: string;

  wheelHandler: any;

  authIframe: any;

  isPopupVisible = false;
  isUserPopupVisible = false;
  isLanguagePopupVisible = false;
  isVisitFilterPopupVisible = false;

  sidebarVisible: boolean = true;
  divMainAppClass: string = 'mdl-layout mdl-js-layout mdl-layout--fixed-drawer';

  selectedVisitOptions: VisitSelectionEvent;
  @ViewChild('mapApp1') mapComponent1: MapComponent;
  @ViewChild('mapApp2') mapComponent2: MapComponent;
  barsVisibleGlobal = true;

  constructor(private sharedService: SharedService, @Inject(Http) private http: Http, public sanitizer: DomSanitizer) {

    this.sharedService.loginEvent.subscribe(jCurrentUser => {
      this.sharedService.shareObj['global'] = jCurrentUser;
      localStorage.setItem('currentUser', jCurrentUser);
      var currentUser = JSON.parse(jCurrentUser);
      this.token = localStorage.getItem('signature');
      this.accounId = currentUser.id;
      this.accountName = currentUser.accountName;
      this.actualTab = ViewTabs.Map;
      this.sharedService.displayLoader(false);
    });

    this.sharedService.logoutEvent.subscribe(message => {
      this.sharedService.shareObj['global'] = '[]';
      localStorage.removeItem('currentUser');
      this.loginMessage = message;
      localStorage.removeItem('signature');
      this.token = '';
      this.sharedService.displayLoader(false);
    });

    this.sharedService.tabEvent.subscribe(tabView => {
      this.actualTab = tabView;
      this.sharedService.displayLoader(false);
    });

    this.sharedService.userEvent.subscribe(data => {
      this.user = data;
    });

    this.sharedService.barsVisible$.subscribe(visible => {
      this.barsVisibleGlobal = visible;
    });
  }

  ngAfterViewChecked() {
    if (componentHandler) componentHandler.upgradeAllRegistered();
  }

  ngOnInit() {
    sessionStorage.clear();
    let lang = localStorage.getItem('language');
    if (lang == null) {
      lang = navigator.language.substr(0, 2);
    }
    this.languages = this.getLanguageList();
    this.setLanguage(lang);

    let currentUser: any;
    let jCurrentUser: any;

    this.wheelHandler = this.receiveMessageLogout.bind(this);

    jCurrentUser = this.sharedService.shareObj['global'];
    if (jCurrentUser) {
      currentUser = JSON.parse(this.sharedService.shareObj['global']);
    } else {
      jCurrentUser = localStorage.getItem('currentUser');
      if (jCurrentUser) {
        currentUser = JSON.parse(localStorage.getItem('currentUser'));
      }
    }

    if (currentUser && localStorage.getItem('signature')) {
      this.token = localStorage.getItem('signature');
      this.accounId = currentUser.id;
      if (currentUser.accountName)
        this.accountName = currentUser.accountName;
      else
        this.accountName = this.accounId;
    }

    document.addEventListener('click', this.onDocumentClick.bind(this));
  }

  setLegendPopupLabels() {

    this.groupedIcons = {
      'Meetingtype': {
        description: this.labels.LegendaPopup['Meetingtype'],
        items: [
          { icon: this.sharedService.getImageUrl('meetingtype_recurring_red'), label: this.labels.LegendaPopup['Recurring'] },
          { icon: this.sharedService.getImageUrl('meetingtype_oneshot_cyan'), label: this.labels.LegendaPopup['Oneshot'] },
          { icon: this.sharedService.getImageUrl('meetingtype_booster_grey'), label: this.labels.LegendaPopup['Booster'] },
          { icon: this.sharedService.getImageUrl('meetingtype_priority_violet'), label: this.labels.LegendaPopup['Priority'] }
        ]
      },
      'Outcome': {
        description: this.labels.LegendaPopup['Outcome'],
        items: [
          { icon: this.sharedService.getImageUrl('outcome_orderplaced_green'), label: this.labels.LegendaPopup['Orderplaced'] },
          { icon: this.sharedService.getImageUrl('outcome_notdemand_yellow'), label: this.labels.LegendaPopup['Notdemand'] }
        ]
      }
    };


  }


  getGroupedIconsKeys(): string[] {
    return Object.keys(this.groupedIcons);
  }

  onSidebarButtonClicked(newState: boolean) {
    this.sidebarVisible = newState;
    if (this.sidebarVisible) {
      if (!this.divMainAppClass.includes('mdl-layout--fixed-drawer')) {
        this.divMainAppClass += ' mdl-layout--fixed-drawer';
      }
    } else {
      this.divMainAppClass = this.divMainAppClass.replace('mdl-layout--fixed-drawer', '').trim();
    }
  }


  onLegendaButtonClicked() {
    this.isPopupVisible = !this.isPopupVisible;
    this.isUserPopupVisible = false;
    this.isLanguagePopupVisible = false;
    this.isVisitFilterPopupVisible = false;
    this.sharedService.isVendorPopupVisible = false;
  }

  onVisitFilterButtonClicked() {
    this.isVisitFilterPopupVisible = !this.isVisitFilterPopupVisible
    this.isPopupVisible = false;
    this.isUserPopupVisible = false;
    this.isLanguagePopupVisible = false;
    this.sharedService.isVendorPopupVisible = false;

    if (this.isVisitFilterPopupVisible) {
      setTimeout(() => {
        document.addEventListener('click', this.handleOutsideVisitFilter);
      });
    } else {
      document.removeEventListener('click', this.handleOutsideVisitFilter);
    }

  }

  onSplitViewButtonClicked() {
    this.sharedService.isSplitView = !this.sharedService.isSplitView;
    this.Refresh();
  }

  userButtonClicked() {
    this.isUserPopupVisible = !this.isUserPopupVisible;
    this.isPopupVisible = false;
    this.isLanguagePopupVisible = false;
    this.isVisitFilterPopupVisible = false;
    this.sharedService.isVendorPopupVisible = false;

    if (this.isUserPopupVisible) {
      setTimeout(() => {
        document.addEventListener('click', this.handleOutsideUserPopupClick);
      });
    } else {
      document.removeEventListener('click', this.handleOutsideUserPopupClick);
    }
  }

  handleOutsideUserPopupClick = (event: Event) => {
    const target = event.target as HTMLElement;
    const clickedInside = target.closest('.user-popup');
    if (!clickedInside) {
      this.isUserPopupVisible = false;
      document.removeEventListener('click', this.handleOutsideUserPopupClick);
    }
  }

  handleOutsideVisitFilter = (event: Event) => {
    const target = event.target as HTMLElement;
    const clickedInside = target.closest('.visit-popup');
    if (!clickedInside) {
      this.isVisitFilterPopupVisible = false;
      document.removeEventListener('click', this.handleOutsideVisitFilter);
    }
  }


  languageButtonClicked() {
    this.isLanguagePopupVisible = !this.isLanguagePopupVisible;
    this.isPopupVisible = false;
    this.isUserPopupVisible = false;
    this.isVisitFilterPopupVisible = false;
    this.sharedService.isVendorPopupVisible = false;

    if (this.isLanguagePopupVisible) {
      setTimeout(() => {
        document.addEventListener('click', this.handleOutsideLanguagePopupClick);
      });
    } else {
      document.removeEventListener('click', this.handleOutsideLanguagePopupClick);
    }
  }

  handleOutsideLanguagePopupClick = (event: Event) => {
    const target = event.target as HTMLElement;
    const clickedInside = target.closest('.language-popup');
    if (!clickedInside) {
      this.isLanguagePopupVisible = false;
      document.removeEventListener('click', this.handleOutsideLanguagePopupClick);
    }
  }

  Refresh(): void {
    this.sharedService.EmitTourPlan();
  }


  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (this.isPopupVisible) {
      const clickedOnButton = target.closest('.popup-button');
      const clickedOnPopup = target.closest('.custom-popup');
      if (!clickedOnButton && !clickedOnPopup) {
        this.isPopupVisible = false;
      }
    }
  }

  private logOut() {
    let that = this;
    this.sharedService.setUser(null)
    if (JSON.parse(localStorage.getItem('authInfo')) && JSON.parse(localStorage.getItem('authInfo')).authurl) {
      let confUrlObj = getUrlTokenServiceIframe();

      that.tokenServiceFolder = confUrlObj.tokenServiceFolder;

      if (document.getElementById("authiframe")) {
        that.authIframe = document.getElementById("authiframe");
        that.authIframe.contentWindow.postMessage("logout", that.tokenServiceFolder);
      }

      let logoutListener = function (e) {
        var key = e.message ? 'message' : 'data';
        var data = e[key];

        if (e.origin == that.iframeBaseUrl && data && data === 'logout') {
          if (that.authIframe)
            that.authIframe.remove();

          window.removeEventListener('message', logoutListener);
        }
      }

      window.addEventListener('message', logoutListener);
    }

    that.sharedService.logOut('Logged off');
  }

  receiveMessageLogout: any = (e: any) => {
    let that = this;

    const key = e.message ? 'message' : 'data';
    const data = e[key];

    if (e.origin == that.iframeBaseUrl) {
      window.removeEventListener('message', that.wheelHandler);

      that.sharedService.logOut('Logged off');
    }
  }

  private changeLanguage(event: Event) {
    const input = event.target as HTMLInputElement;
    const selectedLang = input.value;
    this.setLanguage(selectedLang);
    this.sharedService.EmitTourPlan();
  }

  private setLanguage(lang: string) {
    this.http.get('./assets/languages/' + lang.toLowerCase() + '.json')
      .map(response => <Labels>response.json())
      .subscribe(
        response => {
          this.labels = response;
          this.language = lang.toUpperCase();
          localStorage.setItem('language', this.language.toLowerCase());
          this.sharedService.setVisitFilterOptionsSource(this.labels);
          this.setLegendPopupLabels();
        },
        error => {
          this.http.get('./assets/languages/en.json')
            .map(response => <Labels>response.json())
            .subscribe(
              response => {
                this.labels = response;
                this.language = 'en';
                localStorage.setItem('language', this.language);
              },
              error => this.labels = new Labels(),
              () => console.log('Default language EN Loaded')
            );
        },
        () => console.log('Language ' + lang + ' Loaded')
      );
  }

  private getLanguageList() {
    let languages = new Array<string>();
    languages.push('de');
    languages.push('en');
    languages.push('it');
    return languages;
  }

  private deleteAllCookies() {
    var cookies = document.cookie.split(";");

    for (var i = 0; i < cookies.length; i++) {
      var cookie = cookies[i];
      var eqPos = cookie.indexOf("=");
      var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
    }
  }

  toggleLegendPopover(event: MouseEvent) {
    event.stopPropagation(); // evita chiusura immediata
    this.isPopoverOpen = !this.isPopoverOpen;

    if (this.isPopoverOpen) {
      setTimeout(() => {
        document.addEventListener('click', this.handleOutsideClick);
      });
    } else {
      document.removeEventListener('click', this.handleOutsideClick);
    }
  }

  handleOutsideClick = (event: Event) => {
    const target = event.target as HTMLElement;
    const clickedInside = target.closest('#legend-menu') || target.closest('.popover');
    if (!clickedInside) {
      this.isPopoverOpen = false;
      document.removeEventListener('click', this.handleOutsideClick);
    }
  }

  onVisitOptionChanged(event: VisitSelectionEvent) {
    this.selectedVisitOptions = event;
    if ((event.lastChanged.key == VisitFilterType.Outcome.toString()) || (event.lastChanged.key == VisitFilterType.ShowUserPosition.toString())) {
      const isOutcome = event.lastChanged.key === VisitFilterType.Outcome.toString();
      if (this.mapComponent1 != undefined) {
        if (isOutcome)
          this.mapComponent1.isReportsChecked = !this.mapComponent1.isReportsChecked;
        this.mapComponent1.ShowMarkers();
      }

      if (this.mapComponent2 != undefined) {
        if (isOutcome)
          this.mapComponent2.isReportsChecked = !this.mapComponent2.isReportsChecked;
        this.mapComponent2.ShowMarkers();
      }

    }
    else {
      if (this.mapComponent1 != undefined)
        this.mapComponent1.onVisitFilterChanged(this.selectedVisitOptions);

      if (this.mapComponent2 != undefined)
        this.mapComponent2.onVisitFilterChanged(this.selectedVisitOptions);
    }

  }

}

export function initConfig(config: ConfigService) {
  return () => config.load();
}

@NgModule({
  imports: [
    BrowserModule,
    ReactiveFormsModule,
    FormsModule,
    HttpModule,
    NguiModule,
    CommonModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyBx2bwNnDpttVX6ldF7Yacgg2J84J81bTQ',
      libraries: ["places"]
    }),
    ChartsModule,
    PopoverModule.forRoot()
  ],
  providers: [
    ConfigService,
    WindowRefService,
    {
      provide: APP_INITIALIZER,
      useFactory: initConfig,
      deps: [ConfigService],
      multi: true
    }
  ],
  declarations: [
    App,
    BarComponent,
    MapComponent,
    WltComponent,
    KpiComponent,
    VdtComponent,
    LoginComponent,
    DirectionsMapDirective,
    MeetingInfoComponent,
    HeaderComponent,
    BottomBarComponent,
    VisitFilterPopupComponent
  ],
  entryComponents: [
    MeetingInfoComponent
  ],
  bootstrap: [App]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts